export type Initiative = {
  actionPlanType?: ActionPlanType;
  changed?: string;
  created?: string;
  initiativeType?: InitiativeType;
  id: string;
  priority?: Priority;
  resource?: Resource;
  title?: string;
  userId?: string;
  initiativeHyperlink?: string;
  crIsIncluded?: boolean;
  // These fields come from action plan, not from initiative list
  initiativeDueDate?: string;
  initiativeNote?: string;
};

export type AssignedInitiative = {
  initiativeId: string;
  initiativeActionPlanType: ActionPlanType;
  initiativeDueDate: string;
  initiativeNote: string;
};

export enum ActionPlanType {
  team_plan = 'Team Plan',
  guest_plan = 'Guest Plan',
  higher_tickets_plan = 'Higher Tickets Plan',
}

export enum Priority {
  low = 'Low',
  medium = 'Medium',
  high = 'High',
}

export enum InitiativeType {
  retain = 'Retain',
  recruit = 'Recruit',
  both = 'Both',
  service_revenue = 'Service Revenue',
  retail_revenue = 'Retail Revenue',
}

export enum Resource {
  marketing_resources = 'Marketing Resources',
  education_resources = 'Education Resources',
  culture_of_care_resources = 'Culture of Care Resources',
}
